import React, { Component, Fragment } from 'react';
import { BrowserRouter as Router, withRouter } from 'react-router-dom';
import { Switch, Route, Link } from 'react-router-dom';

import { toast } from 'react-toastify';

import ListadoMenu from '../Admin/Menu/menu';
import RootIndex from './index';

import Boletin from '../Admin/Boletin/boletin';
import Recurso from '../Admin/Recurso/recurso';
import DetalleRecurso from '../Admin/DetalleRecurso/detalle-recurso';
import Categoria from '../Admin/Categoria/categoria';
import Area from '../Admin/Area/area';
import Adjunto from '../Admin/Adjunto/adjunto';
import TipoAdjunto from '../Admin/TipoAdjunto/tipo-adjunto';
import Etiqueta from '../Admin/Etiqueta/etiqueta';
import Enlace from '../Admin/Enlace/enlace';
import Ubicacion from '../Admin/Ubicacion/ubicacion';
import Parametro from '../Admin/Parametro/parametro';
import LineaProducto from '../Admin/LineaProducto/linea-producto';
import TipoRecurso from '../Admin/TipoRecurso/tipo-recurso';
import TipoDetalleRecurso from '../Admin/TipoDetalleRecurso/tipo-detalle-recurso';
import Sector from '../Admin/Sector/sector';
import EditTipoRecurso from '../Admin/TipoRecurso/edit-tipo-recurso';
import AddTipoRecurso from '../Admin/TipoRecurso/add-tipo-recurso';
import EditRecurso from '../Admin/Recurso/edit-recurso';
import AddRecurso from '../Admin/Recurso/add-recurso';
import AddBoletin from '../Admin/Boletin/add-boletin';
import EditBoletin from '../Admin/Boletin/edit-boletin';
import EditSector from '../Admin/Sector/edit-sector';
import AddSector from '../Admin/Sector/add-sector';

import Administradores from './administradores';
import Reportes from './reportes';
import Configuradores from './configuradores';
import CategoriaCalendarioFormacion from '../Admin/CategoriaCalendarioFormacion/categoria-calendario-formacion';
import CategoriaCertificacion from '../Admin/CategoriaCertificacion/categorias-certificacion';
import CategoriasExportaFacil from '../Admin/CategoriaExportaFacil/categorias-exporta-facil';
import CategoriasFaq from '../Admin/CategoriaFaq/categorias-faq';
import CategoriasHerramientaAnalisis from '../Admin/CategoriaHerramientaAnalisis/categorias-herramienta-analisis';
import CategoriasPuedeInteresarte from '../Admin/CategoriaPuedeInteresarte/categorias-puede-interesarte';
import AgregarCategoriaCertificacion from '../Admin/CategoriaCertificacion/agregar-categoria-certificacion';
import EditarCategoriaCertificacion from '../Admin/CategoriaCertificacion/editar-categoria-certificacion';
import HerramientasAnalisis from '../Admin/HerramientaAnalisis/herramientas-analisis';
import AgregarHerramientaAnalisis from '../Admin/HerramientaAnalisis/agregar-herramienta-analisis';
import EditarHerramientaAnalisis from '../Admin/HerramientaAnalisis/editar-herramienta-analisis';
import HerramientasPyme from '../Admin/HerramientaPyme/herramientas-pyme';
import EditarHerramientaPyme from '../Admin/HerramientaPyme/editar-herramienta-pyme';
import AgregarHerramientaPyme from '../Admin/HerramientaPyme/agregar-herramienta-pyme';
import HerramientasExternas from '../Admin/HerramientaExterna/herramientas-externa';
import AgregarHerramientaExterna from '../Admin/HerramientaExterna/agregar-herramienta-externa';
import EditarHerramientaExterna from '../Admin/HerramientaExterna/editar-herramienta-externa';
import ProgramasCapacitacion from '../Admin/ProgramaCapacitacion/programas-capacitacion';
import AgregarProgramaCapacitacion from '../Admin/ProgramaCapacitacion/agregar-programa-capacitacion';
import EditarProgramaCapacitacion from '../Admin/ProgramaCapacitacion/editar-programa-capacitacion';
import Certificaciones from '../Admin/Certificacion/certificaciones';
import AgregarCertificacion from '../Admin/Certificacion/agregar-certificacion';
import EditarCertificacion from '../Admin/Certificacion/editar-certificacion';
import Glosario from '../Admin/Glosario/glosario';
import PuedeInteresarte from '../Admin/PuedeInteresarte/puede-interesarte';
import AgregarPuedeInteresarte from '../Admin/PuedeInteresarte/agregar-puede-interesarte';
import EditarPuedeInteresarte from '../Admin/PuedeInteresarte/editar-puede-interesarte';
import Logs from '../Admin/Reportes/reporte-logs';
import Trazabilidad from '../Admin/Reportes/reporte-trazabilidad';
import Encuesta from '../Admin/Reportes/reporte-encuesta';
import SuscriptorFooter from '../Admin/Reportes/reporte-suscriptor-footer';
import DocumentoExportacion from '../Admin/DocumentoExportacion/documento-exportacion';
import AgregarDocumentoExportacion from '../Admin/DocumentoExportacion/agregar-documento-exportacion';
import EditarDocumentoExportacion from '../Admin/DocumentoExportacion/editar-documento-exportacion';
import GuiaExportador from '../Admin/GuiaExportador/guia-exportador';
import AgregarGuiaExportador from '../Admin/GuiaExportador/agregar-guia-exportador';
import EditarGuiaExportador from '../Admin/GuiaExportador/editar-guia-exportador';
import AgregarCategoriaExportaFacil from '../Admin/CategoriaExportaFacil/agregar-categoria-exporta-facil';
import EditarCategoriaExportaFacil from '../Admin/CategoriaExportaFacil/editar-categoria-exporta-facil';
import AgregarCategoriaFaq from '../Admin/CategoriaFaq/agregar-categoria-faq';
import EditarCategoriaFaq from '../Admin/CategoriaFaq/editar-categoria-faq';
import AgregarCategoriaHerramientaAnalisis from '../Admin/CategoriaHerramientaAnalisis/agregar-categoria-herramienta-analisis';
import EditarCategoriaHerramientaAnalisis from '../Admin/CategoriaHerramientaAnalisis/editar-categoria-herramienta-analisis';
import EditarCategoriaPuedeIntersarte from '../Admin/CategoriaPuedeInteresarte/editar-categoria-puede-interesarte';
import AgregarCategoriaPuedeIntersarte from '../Admin/CategoriaPuedeInteresarte/agregar-categoria-puede-interesarte';
import Faqs from '../Admin/Faq/faqs';
import AgregarFaq from '../Admin/Faq/agregar-faq';
import EditarFaq from '../Admin/Faq/editar-faq';
import OficinasMundo from '../Admin/OficinaMundo/oficinas-mundo';
import AgregarOficinaMundo from '../Admin/OficinaMundo/agregar-oficina-mundo';
import EditarOficinaMundo from '../Admin/OficinaMundo/editar-oficina-mundo';
import ExportaFacil from '../Admin/ExportaFacil/exporta-facil';
import AgregarExportaFacil from '../Admin/ExportaFacil/agregar-exporta-facil';
import EditarExportaFacil from '../Admin/ExportaFacil/editar-exporta-facil';
import ProductoPriorizado from '../Admin/ProductoPriorizado/productos-priorizado';
import AgregarProductoPriorizado from '../Admin/ProductoPriorizado/agregar-producto-priorizado';
import EditarProductoPriorizado from '../Admin/ProductoPriorizado/editar-producto-priorizado';
import CategoriaPotencialExportador from '../Admin/CategoriaPotencialExportador/categorias-potencial-exportador';
import AgregarCategoriaPotencialExportador from '../Admin/CategoriaPotencialExportador/agregar-categoria-potencial-exportador';
import EditarCategoriaPotencialExportador from '../Admin/CategoriaPotencialExportador/editar-categoria-potencial-exportador';
import Paginas from '../Admin/Pagina/paginas';
import AgregarPagina from '../Admin/Pagina/agregar-pagina';
import EditarPagina from '../Admin/Pagina/editar-pagina';
import Permisos from './permisos';
import Usuarios from '../Admin/Usuarios/usuarios';
import AgregarUsuario from '../Admin/Usuarios/agregar-usuario';
import Perfiles from '../Admin/Perfiles/perfiles';
import AgregarPerfil from '../Admin/Perfiles/agregar-perfil';
import EditarUsuario from '../Admin/Usuarios/editar-usuario';
import ListarPagina from '../Admin/Usuarios/listar-pagina';
import AsignarPagina from '../Admin/Usuarios/asignar-pagina';

import EditarPerfil from '../Admin/Perfiles/editar-perfil';
import FichaPais from '../Admin/FichaPais';
import FichaPaisConsejeros from '../Admin/FichaPais/consejeros';
import FichaPaisNuevo from '../Admin/FichaPais/add';
import FichaPaisEditar from '../Admin/FichaPais/edit';
import FichaProducto from '../Admin/FichaProducto';
import FichaProductoNuevo from '../Admin/FichaProducto/add';
import FichaProductoEditar from '../Admin/FichaProducto/edit';
import FichaProductoCertificados from '../Admin/FichaProducto/certificados';
import FichaProductoPartidas from '../Admin/FichaProducto/partidas';
import Evento from '../Admin/Evento';
import EventoNuevo from '../Admin/Evento/add';
import EventoEditar from '../Admin/Evento/edit';

import FichaPartida from '../Admin/FichaPartida';
import FichaPartidaEditar from '../Admin/FichaPartida/edit';

import Eventos from '../Admin/Eventos';
import AddEvento from '../Admin/Eventos/Add';
import EditarEvento from '../Admin/Eventos/Edit';
import { API_URL } from '../../constants';

import cookie from 'react-cookies';
import axios from 'axios';
import Page403 from '../Admin/403';
import PrivateComponent from './PrivateComponent';
import Notificaciones from './notificaciones';
import VerNotificacion from './notificaciones/VerNotificacion';
import Page404 from '../Admin/404';
import CrearNotificacion from './notificaciones/Crear.js';
import CachePanel from '../Admin/Cache';
import Emailing from '../Admin/Emailing/index.js';
import AddEmailing from '../Admin/Emailing/Add.js';
import EditEmailing from '../Admin/Emailing/Edit.js';

class Routes extends Component {
    constructor(props){
        super(props);

        this.state = {
            options:        localStorage.getItem("useropt"),
            menu:           props.menu,
            menuGeneral:    props.menuGeneral,
            security:       cookie.load('user'),
            validating:     true,
            loading:        true
        } 
    }

    validateRoute (Surl = "") {
        this.setState({
            validating: true
        }, () => {

            const user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : null;
            const routesPerSuperUsu = [
                '/cache'
            ];

            const redirectTo403 = () =>{
                // console.log("redireccionando 403");
                const location = {
                    pathname: '/403',
                    state: { message: `No tiene permisos ver la página: ${Surl}` }
                }
                this.props.history.push(location);
            }

            if(Surl !== "/" && Surl !== "/403"){
                let dataurl = encodeURIComponent(Surl);
                //const url = `${API_URL}OpcionUX/GetOptionsByUser/${this.state.security.nUsuCodigo}`;
                const url = `${API_URL}OpcionUX/GetOptionUserHasPermByUrl/${this.state.security.nUsuCodigo}/${dataurl}`;

                axios.get(url)
                .then(response => response.data)
                .then((data) => {
                    if(data.statusCode !== 200){
                        //error
                        redirectTo403();
                    }else{
                        if(routesPerSuperUsu.includes(Surl)){
                            if(!user.Tusu_EsSuperAdmin){
                                redirectTo403();
                            }else{
                                this.setState({
                                    validating: false,
                                    // loading: false
                                });
                            }
                        }else{
                            this.setState({
                                validating: false,
                                // loading: false
                            });
                        }
                    }
                })
                .catch(error => {
                    console.log(error);
                });
            }else{
                this.setState({
                    validating: false,
                    // loading: false
                });
            }
            
        });
    }

    componentDidMount() {
        if(this.state.loading){
            const {history} = this.props;
            // console.log("data route", history.location.pathname);
            this.validateRoute(history.location.pathname);
        }
    }

    componentWillMount() {
        this.unlisten = this.props.history.listen((location, action) => {
        //   console.log("on route change to:", location);
          this.validateRoute(location.pathname);
        });
    }
  
    componentWillUnmount() {
        // this.unlisten();
    }

    render(){

        // console.log(this.state);

        return(
            <Switch>
                    <Route exact path="/" 
                        render={(props) => <RootIndex 
                            menu={this.state.menu} 
                            menuGeneral={this.state.menuGeneral} 
                        />}
                    />
                    
                    {!this.state.validating && [
                       
                            <Route path='/area' component={Area} />,
                            <Route path='/adjunto' component={Adjunto} />,
                            <Route path='/tipo-adjunto' component={TipoAdjunto} />,
                            <Route path='/etiqueta' component={Etiqueta} />,
                            <Route path='/enlace' component={Enlace} />,
                            <Route path='/ubicacion' component={Ubicacion} />,
                            <Route path='/linea-producto' component={LineaProducto} />,
                            <Route path='/parametro' component={Parametro} />,

                            <Route path='/tipo-recurso' component={TipoRecurso} />,
                            <Route path='/recurso' component={Recurso} />,
                            <Route path='/detalle-recurso' component={DetalleRecurso} />,
                            <Route path='/tipo-detalle-recurso' component={TipoDetalleRecurso} />,
                            <Route path='/categoria' component={Categoria} />,
                            <Route path='/boletin' component={Boletin} />,
                            <Route path='/sector' component={Sector} />,
                            <Route path='/edit-recurso' component={EditRecurso} />,
                            <Route path='/add-recurso' component={AddRecurso} />,
                            <Route path='/add-boletin' component={AddBoletin} />,
                            <Route path='/edit-boletin' component={EditBoletin} />,
                            <Route path='/edit-tipo-recurso' component={EditTipoRecurso} />,
                            <Route path='/add-tipo-recurso' component={AddTipoRecurso} />,
                            <Route path='/edit-sector' component={EditSector} />,
                            <Route path='/add-sector' component={AddSector} />,

                            <Route path='/menu' component={ListadoMenu} />,
                            <Route path='/categorias-calendario-formacion' component={CategoriaCalendarioFormacion} />,

                            <Route path='/ficha-pais' component={FichaPais} />,
                            <Route path='/agregar-ficha-pais' component={FichaPaisNuevo} />,
                            <Route path='/editar-ficha-pais/:id' component={FichaPaisEditar} />,
                            <Route path='/ficha-pais-consejeros/:id' component={FichaPaisConsejeros} />,
                            
                            <Route path='/ficha-producto' component={FichaProducto} />,
                            <Route path='/agregar-ficha-producto' component={FichaProductoNuevo} />,
                            <Route path='/editar-ficha-producto/:id' component={FichaProductoEditar} />,
                            <Route path='/ficha-producto-certificados/:id' component={FichaProductoCertificados} />,
                            <Route path='/ficha-producto-partidas/:id' component={FichaProductoPartidas} />,

                            <Route path='/ficha-partida' component={FichaPartida} />,
                            <Route path='/editar-ficha-partida/:id' component={FichaPartidaEditar} />,

                            <Route path='/evento' component={Evento} />,
                            <Route path='/agregar-evento' component={EventoNuevo} />,
                            <Route path='/editar-eventos/:id' component={EventoEditar} />,
                            
                            <Route path='/categorias-certificacion' component={CategoriaCertificacion} />,
                            <Route path='/agregar-categoria-certificacion' component={AgregarCategoriaCertificacion} />,
                            <Route path='/editar-categoria-certificacion/:id' component={EditarCategoriaCertificacion} />,

                            <Route path='/categorias-exporta-facil' component={CategoriasExportaFacil} />,
                            <Route path='/agregar-categoria-exporta-facil' component={AgregarCategoriaExportaFacil} />,
                            <Route path='/editar-categoria-exporta-facil/:id' component={EditarCategoriaExportaFacil} />,

                            <Route path='/categorias-faq' component={CategoriasFaq} />,
                            <Route path='/agregar-categoria-faq' component={AgregarCategoriaFaq} />,
                            <Route path='/editar-categoria-faq/:id' component={EditarCategoriaFaq} />,

                            <Route path='/categorias-herramienta-analisis' component={CategoriasHerramientaAnalisis} />,
                            <Route path='/agregar-categoria-herramienta-analisis' component={AgregarCategoriaHerramientaAnalisis} />,
                            <Route path='/editar-categoria-herramienta-analisis/:id' component={EditarCategoriaHerramientaAnalisis} />,

                            <Route path='/categorias-puede-interesarte' component={CategoriasPuedeInteresarte} />,
                            <Route path='/agregar-categoria-puede-interesarte' component={AgregarCategoriaPuedeIntersarte} />,
                            <Route path='/editar-categoria-puede-interesarte/:id' component={EditarCategoriaPuedeIntersarte} />,  

                            <Route path='/herramientas-analisis' component={HerramientasAnalisis} />,
                            <Route path='/agregar-herramienta-analisis' component={AgregarHerramientaAnalisis} />,
                            <Route path='/editar-herramienta-analisis/:id' component={EditarHerramientaAnalisis} />,

                            <Route path='/herramientas-pyme' component={HerramientasPyme} />,
                            <Route path='/agregar-herramienta-pyme' component={AgregarHerramientaPyme} />,
                            <Route path='/editar-herramienta-pyme/:id' component={EditarHerramientaPyme} />,

                            <Route path='/herramientas-externa' component={HerramientasExternas} />,
                            <Route path='/agregar-herramienta-externa' component={AgregarHerramientaExterna} />,
                            <Route path='/editar-herramienta-externa/:id' component={EditarHerramientaExterna} />,

                            <Route path='/programas-capacitacion' component={ProgramasCapacitacion} />,
                            <Route path='/agregar-programa-capacitacion' component={AgregarProgramaCapacitacion} />,
                            <Route path='/editar-programa-capacitacion/:id' component={EditarProgramaCapacitacion} />,

                            <Route path='/certificaciones' component={Certificaciones} />,
                            <Route path='/agregar-certificacion' component={AgregarCertificacion} />,
                            <Route path='/editar-certificacion/:id' component={EditarCertificacion} />,

                            <Route path='/glosario' component={Glosario} />,

                            <Route path='/puede-interesarte' component={PuedeInteresarte} />,
                            <Route path='/agregar-puede-interesarte' component={AgregarPuedeInteresarte} />,
                            <Route path='/editar-puede-interesarte/:id' component={EditarPuedeInteresarte} />,

                            <Route path='/documento-exportacion' component={DocumentoExportacion} />,
                            <Route path='/agregar-documento-exportacion' component={AgregarDocumentoExportacion} />,
                            <Route path='/editar-documento-exportacion/:id' component={EditarDocumentoExportacion} />,

                            <Route path='/guia-exportador' component={GuiaExportador} />,
                            <Route path='/agregar-guia-exportador' component={AgregarGuiaExportador} />,
                            <Route path='/editar-guia-exportador/:id' component={EditarGuiaExportador} />,

                            <Route path='/faqs' component={Faqs} />,
                            <Route path='/agregar-faq' component={AgregarFaq} />,
                            <Route path='/editar-faq/:id' component={EditarFaq} />,

                            <Route path='/oficinas-mundo' component={OficinasMundo} />,
                            <Route path='/agregar-oficina-mundo' component={AgregarOficinaMundo} />,
                            <Route path='/editar-oficina-mundo/:id' component={EditarOficinaMundo} />,

                            <Route path='/exporta-facil' component={ExportaFacil} />,
                            <Route path='/agregar-exporta-facil' component={AgregarExportaFacil} />,
                            <Route path='/editar-exporta-facil/:id' component={EditarExportaFacil} />,

                            <Route path='/productos-priorizado' component={ProductoPriorizado} />,
                            <Route path='/agregar-producto-priorizado' component={AgregarProductoPriorizado} />,
                            <Route path='/editar-producto-priorizado/:id' component={EditarProductoPriorizado} />,

                            <Route path='/categorias-potencial-exportador' component={CategoriaPotencialExportador} />,
                            <Route path='/agregar-categoria-potencial-exportador' component={AgregarCategoriaPotencialExportador} />,
                            <Route path='/editar-categoria-potencial-exportador/:id' component={EditarCategoriaPotencialExportador} />,

                            <Route path='/paginas' component={Paginas} />,
                            <Route path='/agregar-pagina' component={AgregarPagina} />,
                            <Route path='/editar-pagina/:id' component={EditarPagina} />,

                            <Route path='/notificaciones/'       component={Notificaciones} exact />,
                            <Route path='/notificaciones/:id'   component={VerNotificacion} exact />,

                            <Route path='/eventos' component={Eventos} exact />,
                            <Route path='/add-evento/' component={AddEvento} exact />,
                            <Route path='/editar-evento/:id' component={EditarEvento} exact />,

                            <Route path='/cache' component={CachePanel} exact />,

                            <Route 
                                path='/usuarios' 
                                // component={Usuarios} 
                                render={(props) => <Usuarios {...props} menu={this.state.menu} menuGeneral={this.state.menuGeneral}  />}
                            />,
                    
                            <Route path='/agregar-usuario' component={AgregarUsuario} />,
                            <Route path='/editar-usuario/:id' component={EditarUsuario} />,
                            <Route path='/listar-pagina/usuario/:id' component={ListarPagina}  exact/>,
                            <Route path='/asignar-pagina/usuario/:id' component={AsignarPagina}  exact/>,

                            <Route path='/perfiles' component={Perfiles} />,
                            <Route path='/agregar-perfil' component={AgregarPerfil} />,
                            <Route path='/editar-perfil/:id' component={EditarPerfil} />,

                            <Route path='/reporte-logs' component={Logs} />,
                            <Route path='/reporte-trazabilidad' component={Trazabilidad} />,
                            <Route path='/reporte-encuesta' component={Encuesta} />,
                            <Route path='/reporte-suscriptor-footer' component={SuscriptorFooter} />,

                            <Route path='/emailing' component={Emailing} exact />,
                            <Route path='/add-emailing/' component={AddEmailing} exact />,
                            <Route path='/edit-emailing/:id' component={EditEmailing} exact />,
                           
                            <Route 
                                path='/administradores'
                                render={(props) => <Administradores {...props} menu={this.state.menu} menuGeneral={this.state.menuGeneral}  />}
                            />,
                            
                            <Route 
                                path='/permisos' 
                                sensitive={true}
                                // component={Permisos}
                                render={(props) => <Permisos {...props} menu={this.state.menu} menuGeneral={this.state.menuGeneral}  />} 
                            />,

                            <Route 
                                path='/reportes' 
                                // component={Reportes} 
                                render={(props) => <Reportes {...props} menu={this.state.menu} menuGeneral={this.state.menuGeneral}  />} 
                            />,

                            <Route
                                path='/reportes' 
                                render={(props) => <Reportes {...props} menu={this.state.menu} menuGeneral={this.state.menuGeneral}  />}
                            />,

                            <Route
                                path='/configuradores' 
                                render={(props) => <Configuradores {...props} menu={this.state.menu} menuGeneral={this.state.menuGeneral}  />}
                            />,

                            <Route
                                path='/notificaciones/crear/nueva' 
                                exact
                                render={(props) => <CrearNotificacion {...props} menu={this.state.menu} menuGeneral={this.state.menuGeneral}  />}
                            />,

                            <Route
                                path='*' 
                                render={(props) => <Page404 {...props} menu={this.state.menu} menuGeneral={this.state.menuGeneral}  />}
                            />
                      
                    ]}
                    
                    <Route path='/403' component={Page403} />
            </Switch>
        )
        
    }
}

export default withRouter(Routes);